// IMPORTANT: this is a plugin which requires jQuery for initialisation and data manipulation

import { Component, OnInit, ElementRef, Inject, AfterViewInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UserService } from '../../services/user.service';
import { User } from '../../models/user';
import { EbayitemService } from '../../services/ebayitem.service';
import { Ebayitem } from '../../models/gobig/ebayitem';
import swal from 'sweetalert2';
import { Longago } from '../../pipes/longago.pipe';
import { Methods } from '../../shared/methods';
import { DateAdapter } from '@angular/material/core';


declare interface DataTable {
  headerRow: string[];
  footerRow: string[];
  dataRows: string[][];
}

declare const $: any;

@Component({
  selector: 'app-listebayitems-cmp',
  templateUrl: 'listebayitems.component.html',
  providers: [UserService, EbayitemService]
})

export class ListebayitemsComponent implements OnInit, AfterViewInit {

  name: string;
  animal: string;
  public mtds: Methods = new Methods();
  public privilegio;

  public dataTable: DataTable;
  public items: Array<Ebayitem>;
  public identity;
  public token;

  //paginación
  public primerpagina;
  public itemsPerPageSelected = '10';
  public showingTo;
  public showingNav;
  public totalItemsCount;
  public pagePrev;
  public pageNext;
  public pages;
  public actualPage;
  public total_pages;
  
  public percentage = 0;
  
  public loading;
  public loadingTable = false;
  public filter = 0;
  public order = 0;
  public searchString;
  public user;
  public status_user;
  public companySelected;
  public actualType;

  public showOverlay = false;

  public arrayExport;

  public successExport: boolean = false;
  public successHotDeal: boolean = false;

  constructor(public dialog: MatDialog, private _route: ActivatedRoute,
    private titleService: Title,
    private _router: Router,
    private _ebayitemService: EbayitemService,
    private _userService: UserService) {
    this.titleService.setTitle('Ebay Items');
    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
    this.actualType = 'ALL';
    this.arrayExport = [];
  }

  ngOnInit() {
    if (this.identity == null && this.identity.sub) {
      localStorage.clear();
      this._router.navigate(['/pages/lock']);
    } else {
      this.getAllPacientes();
    }
  }
  
  public editPrice = null;
  public tmpPrice = 0;
  public savingPrice = null;
  editarPrice(id, value) {
    console.log('id: ' + id, ' Value: ' + value);
    this.editPrice = id;
    this.tmpPrice = value;
  }

  cancelEditPrice() {
    this.editPrice = null;
    this.tmpPrice = 0;
    this.savingPrice = null;
  }

  savePrice() {
    this.savingPrice = this.editPrice;
    let json = {
      bulk:[this.editPrice],
      type:"price",
      action:this.tmpPrice
    }

    this._ebayitemService.updatebulk(this.token, json).subscribe(
      r => {
        console.log(r);
        if (r.code === 400 && r.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (r.status !== 'success') {
          this.mtds.notifyError(r.msg, r.code);
        } else {
          for (let item of this.dataTable.dataRows) {
            if (item[0] === this.editPrice) {
              item[3] = String(this.tmpPrice.toFixed(2));
              break;
            }
          }
          for(let msge of r.messages) {
            this.mtds.notifyError(msge);
          }
          this.cancelEditPrice();
        }
      }, error => {
        console.log(error);
      }
    );
  }

  public editStock = null;
  public tmpStock = 0;
  public savingStock = null;
  editarStock(id, value) {
    console.log('id: ' + id, ' Value: ' + value);
    this.editStock = id;
    this.tmpStock = value;
  }

  cancelEditStock() {
    this.editStock = null;
    this.tmpStock = 0;
    this.savingStock = null;
  }

  saveStock() {
    this.savingStock = this.editStock;
    let json = {
      bulk:[this.editStock],
      type:"stock",
      action:this.tmpStock
    }

    this._ebayitemService.updatebulk(this.token, json).subscribe(
      r => {
        console.log(r);
        if (r.code === 400 && r.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (r.status !== 'success') {
          this.mtds.notifyError(r.msg, r.code);
        } else {
          for (let item of this.dataTable.dataRows) {
            if (item[0] === this.editStock) {
              item[7] = String(this.tmpStock);
              break;
            }
          }
          for(let msge of r.messages) {
            this.mtds.notifyError(msge);
          }
          this.cancelEditStock();
        }
      }, error => {
        console.log(error);
      }
    );
  }

  public uswerwonted: Array<any> = [];

  wu(id) {
    // console.log(this._ebayitemService.wantedUsers(id));
    this.uswerwonted = [];
    this._ebayitemService.wantedUsers(id).subscribe(
      r => {
        console.log(r);
        this.uswerwonted = r.data;
        $('#myModal').modal('show');
      }
    );
  }

  closeModal() {
    $('#myModal').modal('hide');
    this.uswerwonted = [];
  }

  deleteUser() {
    let id = $("#borrarUser").val();
    console.log(id + "aqui");
    /* this._userService.deleteUser(this.token, id).subscribe(
       response =>{
         if(response.status == 'success'){
           //this._router.navigate(['/']);
          // this.getAllPacientes();
          alert("Done");
         } else {
           alert("No se ha borrado el usuario");
         }
       },
       error => {
         console.log(<any>error);
       }
       );*/
  }

  showSwal(type) {
    if (type === 'success-message') {
      swal.fire({
       
        title: 'Item successfully added!',
        text: '',
        buttonsStyling: false,
   customClass:{
    confirmButton: 'btn btn-success'
            },
      });

    } else if (type === 'warning-message-and-confirmation') {
      swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to revert this!',
      
        showCancelButton: true,
      customClass:{
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger',
            },
        confirmButtonText: 'Yes, delete it!',
        buttonsStyling: false
      }).then(function () {
        swal.fire({
          title: 'Deleted!',
          text: 'Your file has been deleted.',
        
     
 customClass:{
    confirmButton: 'btn btn-success'
            },
          buttonsStyling: false
        });
      });
    } else if (type === 'warning-message-and-cancel') {
      swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this imaginary file!',
       
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      customClass:{
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger',
            },
        buttonsStyling: false
      }).then(function () {
        swal.fire({
          title: 'Deleted!',
          text: 'Your imaginary file has been deleted.',
       
      customClass:{
    confirmButton: 'btn btn-success'
            },
          buttonsStyling: false
        });
      }, function (dismiss) {
        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
        if (dismiss === 'cancel') {
          swal.fire({
            title: 'Cancelled',
            text: 'Your imaginary file is safe :)',
   
          customClass:{
    confirmButton: 'btn btn-info'
            },
            buttonsStyling: false
          });
        }
      });
    } else if (type === 'custom-html') {
      swal.fire({
        title: 'HTML example',
        buttonsStyling: false,
    
        customClass:{
    confirmButton: 'btn btn-success'
            },
        html:
          'You can use <b>bold text</b>, ' +
          '<a href="http://github.com">links</a> ' +
          'and other HTML tags'
      });

    } else if (type === 'auto-close') {
      swal.fire({
        title: 'Auto close alert!',
        text: 'I will close in 2 seconds.',
        timer: 2000,
        showConfirmButton: false
      }).then(
        function () { },
        // handling the promise rejection
        function (dismiss) {
          if (dismiss === 'timer') {
            console.log('I was closed by the timer')
          }
        });
    } else if (type === 'input-field') {
      swal.fire({
        title: 'Input something',
        html: '<div class="form-group">' +
          '<input id="input-field" type="text" class="form-control" />' +
          '</div>',
        showCancelButton: true,
    customClass:{
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger',
            },
        buttonsStyling: false
      }).then(function (result) {
        swal.fire({
       
          html: 'You entered: <strong>' +
            $('#input-field').val() +
            '</strong>',
         customClass:{
    confirmButton: 'btn btn-success'
            },
          buttonsStyling: false

        });
      });
    }
  }


setHotDeal(action){
    let me = this;
    me.loading = "show";
    me.showOverlay = true;

    let enviar = {
      'bulk': this.arrayExport,
      "hot": action,
      "percentage": this.percentage
    }

    this._ebayitemService.hotdeal(this.token, enviar).subscribe(
      response => {
        console.log(response);
        me.showOverlay = false;
        if (response.status == 'success') {

          me.loading = "hide";
          me.successHotDeal = true;
          me.arrayExport = [];
          me.getAllPacientes();
        }

      },
      error => {
        console.log(<any>error);

      }
    );
}

  goExport(type, action) {
    let me = this;
    me.loading = "show";
    me.successExport = false;


    let enviar = {
      'bulk': this.arrayExport,
      'type': type,
      'action': action
    }


    this._ebayitemService.updatebulk(this.token, enviar).subscribe(
      response => {
        console.log(response);
        if (response.status == 'success') {

          me.loading = "hide";
          me.successExport = true;
          me.arrayExport = [];
          me.getAllPacientes();
        }

      },
      error => {
        console.log(<any>error);

      }
    );

  }

  openHotDealModal(){
    this.percentage = 0;
    $('#myModalHotDeal').modal('show');
  }

  closeHotDealModal(param) {

    $('#myModalHotDeal').modal('hide');

    if(param === 0)
      this.percentage = 0;
    else
      this.setHotDeal(1);
  }


  getAllPacientes() {
    this._route.params.forEach((params: Params) => {
      let page = + params['page'];

      if (!page) {
        page = 1;
      }

      if (this.primerpagina === 1) {
        page = 1;
        this.primerpagina = 0;
      }

      this.actualPage = page;
      console.log(this.actualPage);

      this.loading = 'show';
      //this.loadingTable = true;
      this.showOverlay = true;
      this._ebayitemService.getItemsByType(this.token, page, this.itemsPerPageSelected, this.actualType).subscribe(
        response => {
          console.log(response);
          if (response.status == 'success') {
            this.items = response.data;


            this.dataTable = {
              headerRow: ['ID', 'Image', 'Title', 'Price', 'Status', 'Actions'],
              footerRow: ['ID', 'Image', 'Title', 'Price', 'Status', 'Actions'],

              dataRows: [

              ]
            };



            this.items.forEach(function (element) {
              let nameCompany = "";
              if (element.companyLinked != null)
                nameCompany = element.companyLinked.name;

              let imageItem = 'https://www.greenteksolutionsllc.com/images/uploads/' + element.imgFile;
              console.log(imageItem);
              this.dataTable.dataRows.push([element.id, imageItem, element.name, element.price, element.status, element.storeUrl, element.ebayUrl, element.stock, '', element.storeId,element.hotDeals, element.createdAt, element.percentage]);
            }.bind(this));

            this.loading = 'hide';
            //this.loadingTable = false;
            this.showOverlay = false;

            // total paginas
            this.totalItemsCount = response.total_items_count;
            this.showingTo = response.page_actual * response.items_per_page;
            this.showingNav = (response.page_actual * response.items_per_page) - (response.items_per_page - 1);
            this.pages = [];
            this.total_pages = response.total_pages
            console.log('total pages:' + response.total_pages);
            let valorfor = page - 2;
            if (valorfor < 0) {
              valorfor = 0;
            }

            let cont = 0;
            for (let i = valorfor; i < response.total_pages; i++) {
              let vaalortest;
              vaalortest = page - i;
              console.log(vaalortest);

              this.pages.push(i);
              cont++;
              if (cont > 5) {
                break;
              }

            }

            // pagina anterior
            if (page >= 2) {
              this.pagePrev = (page - 1);
            } else {
              this.pagePrev = page;
            }

            // pagina siguiente
            if (page < response.total_pages) {
              this.pageNext = (page + 1);
            } else {
              this.pageNext = page;
            }
          } else {
            localStorage.clear();
            this._router.navigate(['/pages/lock']);

          }
        },
        error => {
          console.log(<any>error);
          //this.loadingTable = false;
          this.showOverlay = false;
        }
      );
    });
  }

 

  deleteItem(id) {

    let json = {
      "bulk": {"id": id}
    }

    console.log(id);

    swal.fire({
      title: "Are you sure to delete item #"+id,
      text: "",
     
      showCancelButton: true,
      buttonsStyling: false,
     customClass:{
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-default',
            },

      confirmButtonColor: "#3085d6",
      confirmButtonText: "Continue",
    }).then(
      function (result) {
        if (result.value) {
        

          this._ebayitemService.removeBulk(this.token, json).subscribe(
            (response) => {
              console.log(response);
              if(response.status != "error")
                $("#user"+id).hide();
              else 
                this.mtds.notifyError(response.msg, response.msg);
            },
            (error) => {
              this.mtds.notifyError(error.statusText, error.status);
            }
          );
        }
      }.bind(this)
    );
  }

  //Paginación
  changeLimit() {
    this.primerpagina = 1;
    this.getAllPacientes();
  }



  ngAfterViewInit() {
    let me = this;
    $('#datatables').DataTable({
      dom: 'Bflrtip',
      buttons: [
        /*{
          extend: 'copy',
          exportOptions: {
            columns: ':visible'
          }
        },*//*
        {
          extend: 'csv',
          exportOptions: {
            columns: ':visible'
          }
        },*/
        {
          extend: 'excel',
          text: '<i class="fa fa-file-excel-o"></i>',
          titleAttr: 'Excel',
          className: 'btn btn-sm btn-outline-success',
          exportOptions: {
            columns: ':visible'
          }
        },
        {
          extend: 'pdf',
          text: '<i class="fa fa-file-pdf-o"></i>',
          titleAttr: 'PDF',
          className: 'btn btn-sm btn-outline-danger',
          exportOptions: {
            columns: ':visible'
          }
        },
        {
          extend: 'print',
          text: '<i class="fa fa-print" aria-hidden="true"></i>',
          titleAttr: 'print',
          className: 'btn btn-sm btn-outline-primary',
          exportOptions: {
            columns: ':visible'
          }
        },
        {
          extend: 'colvis',
          text: '<i class="fa fa-columns" aria-hidden="true"></i>',
          className: 'btn btn-sm btn-outline-info',
          titleAttr: 'Column visibility'
        },
      ],
      "pagingType": "full_numbers",
      "lengthMenu": [
        [10, 25, 50, -1],
        [10, 25, 50, "All"]
      ],
      responsive: true,
      paging: false,
      language: {
        search: "_INPUT_",
        searchPlaceholder: "Search records",
      }

    });

    const table = $('#datatables').DataTable();

    // Edit record
    table.on('click', '.edit', function () {
      console.log("entramos");
      const $tr = $(this).closest('tr');

      const data = table.row($tr).data();
      alert('You press on Row: ' + data[0] + ' ' + data[1] + ' ' + data[2] + '\'s row.');
    });

    // Delete a record
    table.on('click', '.remove', function (e) {
      e.preventDefault();

      var txt;
      var r = confirm("Are you sure to delete this client?");
      if (r == true) {
        const $tr = $(this).closest('tr');
        const data = table.row($tr).data();

        table.row($tr).remove().draw();
        $("#borrarUser").val(data[0]);

        $("#borrarUser").trigger("click");
      } else {

      }


    });


    // Handle click on "Select all" control
    $('#example-select-all').on('click', function () {
      console.log("hola all");
      // Get all rows with search applied
      var rows = table.rows({ 'search': 'applied' }).nodes();
      //console.log(rows);

      let ptest = $('input[type="checkbox"]', rows);



      var allChecked = $('#example-select-all:checkbox:checked').length > 0;

      for (const child of ptest) {

        //console.log(child.id);

        let index = me.arrayExport.indexOf(child.id);
        console.log(index);
        if (index == -1 && allChecked) {
          me.arrayExport.push(child.id);
        } else if (index > -1 && !allChecked) {
          me.arrayExport.splice(index, 1);
        }


      }

      // Check/uncheck checkboxes for all rows in the table
      $('input[type="checkbox"]', rows).prop('checked', this.checked);
    });


    // Handle click on checkbox to set state of "Select all" control
    $('#datatables tbody').on('change', 'input[type="checkbox"]', function (e) {
      // If checkbox is not checked

      console.log("entramos");
      let res = e.currentTarget.id;



      if (!this.checked) {


        let index = me.arrayExport.indexOf(res);
        if (index > -1) {
          me.arrayExport.splice(index, 1);
        }

        var el = $('#example-select-all').get(0);
        // If "Select all" control is checked and has 'indeterminate' property
        if (el && el.checked && ('indeterminate' in el)) {
          // Set visual state of "Select all" control
          // as 'indeterminate'
          el.indeterminate = true;
        }
      } else {
        me.arrayExport.push(res);
      }


    });




    //Like record
    table.on('click', '.like', function () {
      console.log("like");

    });

    $('.card .material-datatables label').addClass('form-group');
  }
}